// src/core/adapters/LondonVisualiserLayout.js
//
// Bus positioning math for the visualiser. Parameterised so per-client
// overrides can change spacing and stacking without touching components.

export const DEFAULT_BUS_HEADWAY_TOLERANCE_SEC = 30;
export const DEFAULT_BUS_VERTICAL_GAP = 25;
export const DEFAULT_BUS_STACK_SPACING = 24;

// ctx: { matchedIndex, totalStops, busAbove, rank, isSelected,
//        verticalGap?, stackSpacing? }
export const computeBusLayout = (bus, ctx) => {
  const {
    matchedIndex,
    totalStops,
    busAbove,
    rank,
    isSelected,
    verticalGap = DEFAULT_BUS_VERTICAL_GAP,
    stackSpacing = DEFAULT_BUS_STACK_SPACING,
  } = ctx;

  let positionPercent = 0;
  if (matchedIndex !== undefined && totalStops > 1) {
    positionPercent = (matchedIndex / (totalStops - 1)) * 100;
  }

  const verticalOffset = rank !== undefined ? rank * stackSpacing : 0;
  const top = busAbove
    ? `calc(50% - ${verticalGap}px - ${verticalOffset}px)`
    : `calc(50% + ${verticalGap}px + ${verticalOffset}px)`;

  let zIndex = 10;
  if (isSelected) {
    zIndex = 999;
  } else if (rank !== undefined) {
    zIndex = busAbove ? 20 - rank : 10 + rank;
  }

  return { positionPercent, top, zIndex };
};